import {
  IconAlertCircle,
  IconChevronDown,
  IconChevronsUp,
  IconChevronUp,
  IconCircleCheck,
  IconCircleDashed,
  IconCircleOff,
  IconDots,
  IconExclamationMark,
  IconHomeDollar,
  IconInfoCircle,
  IconPaintOff,
  IconPlaystationCircle,
  IconPlaystationX,
  IconTool,
  IconUserExclamation,
} from '@tabler/icons-react'

import { buildPassTheme } from 'src/styles/theme'

import { DefectPriority, DefectStatus } from 'types/api.graphql'

export const CLOSED_DEFECT_STATUSES = [
  DefectStatus.Resolved,
  DefectStatus.Cancelled,
]

export const DEFECT_STATUSES = {
  [DefectStatus.ToDo]: {
    labelPath: 'defect:status.toDo',
    icon: <IconInfoCircle size={16} />,
    variant: 'warning',
    category: null,
  },
  [DefectStatus.InProgress]: {
    labelPath: 'defect:status.inProgress',
    icon: <IconCircleDashed size={16} />,
    variant: 'success',
    category: 'Open',
  },
  [DefectStatus.WaitingReview]: {
    labelPath: 'defect:status.waitingReview',
    icon: <IconCircleCheck size={16} />,
    variant: 'success',
    category: 'Open',
  },
  [DefectStatus.Blocked]: {
    labelPath: 'defect:status.blocked',
    icon: <IconCircleOff size={16} />,
    variant: 'success',
    category: 'Open',
  },
  [DefectStatus.Resolved]: {
    labelPath: 'defect:status.resolved',
    icon: <IconPlaystationCircle size={16} />,
    variant: undefined,
    category: 'Closed',
  },
  [DefectStatus.Cancelled]: {
    labelPath: 'defect:status.cancelled',
    icon: <IconPlaystationX size={16} />,
    variant: undefined,
    category: 'Closed',
  },
}

export const FALLBACK_STATUSES = [
  DefectStatus.ToDo,
  DefectStatus.InProgress,
  DefectStatus.WaitingReview,
  DefectStatus.Blocked,
  DefectStatus.Resolved,
  DefectStatus.Cancelled,
]

export const OVERDUE_STATUS = {
  labelPath: 'defect:status.overdue',
  icon: <IconAlertCircle size={16} />,
  colour: buildPassTheme.colour.semantic.errorDark,
  haloColour: buildPassTheme.colour.semantic.errorLight,
  category: 'Open',
  variant: undefined,
}

export const DEFECT_TYPES = {
  BUILDER_DEFECT: {
    labelPath: 'defect:types.builderDefect',
    icon: <IconTool size={16} />,
  },
  CLIENT_DEFECT: {
    labelPath: 'defect:types.clientDefect',
    icon: <IconUserExclamation size={16} />,
  },
  INCOMPLETE_WORKS: {
    labelPath: 'defect:types.incompleteWorks',
    icon: <IconPaintOff size={16} />,
  },
  PURCHASER_DEFECT: {
    labelPath: 'defect:types.purchaserDefect',
    icon: <IconHomeDollar size={16} />,
  },
}

export const DEFECT_PRIORITIES = {
  [DefectPriority.Low]: {
    labelPath: 'defect:priorities.low',
    colour: buildPassTheme.colour.secondary._400,
    icon: <IconChevronDown size={16} />,
  },
  [DefectPriority.Medium]: {
    labelPath: 'defect:priorities.medium',
    colour: buildPassTheme.colour.semantic.warningDark,
    icon: <IconChevronUp size={16} />,
  },
  [DefectPriority.High]: {
    labelPath: 'defect:priorities.high',
    colour: buildPassTheme.colour.other.orange,
    icon: <IconChevronsUp size={16} />,
  },
  [DefectPriority.Critical]: {
    labelPath: 'defect:priorities.critical',
    colour: buildPassTheme.colour.semantic.errorDark,
    icon: <IconExclamationMark size={16} />,
  },
}

export const DEFECT_FALLBACK_PRIORITY = {
  labelPath: 'defect:priorities.noPriority',
  icon: <IconDots size={16} />,
  colour: buildPassTheme.colour.secondary._500,
}
